import { camelCaseFixTag, fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

const TAG_TYPES = {
  count: "Count",
  comments: "Comments",
};

export const commentApi = createApi({
  reducerPath: "comments",
  baseQuery: fetchBaseQueryWrapper({
    path: "comments",
  }),
  tagTypes: [TAG_TYPES.count],
  endpoints: (build) => ({
    createTag: build.mutation({
      query: (body) => ({
        url: "tags",
        method: "POST",
        body: body,
      }),
      transformResponse: (response) => response.data.data,
    }),
    getTags: build.query({
      query: () => "tags",
      transformResponse: (response) => camelCaseFixTag(response.data),
    }),
  }),
});

export const { useCreateTagMutation, useGetTagsQuery } = commentApi;
